import { CTSType } from "fond/types";

export interface CostRange {
  min: number;
  max: number;
}

/**
 * Computes the min and max of `costs` in a single pass. `Math.min(...costs)`/`Math.max(...costs)`
 * spread the array as call arguments, which can throw "Maximum call stack size exceeded" once
 * there are enough service locations to exceed the engine's argument-count limit.
 */
export const getCostRange = (costs: number[]): CostRange => {
  let min = costs[0];
  let max = costs[0];

  for (let i = 1; i < costs.length; i += 1) {
    const cost = costs[i];
    if (cost < min) min = cost;
    if (cost > max) max = cost;
  }

  return { min, max };
};

interface CtsTypeOption {
  value: CTSType;
  label: string;
}

export const CTS_TYPE_OPTIONS: CtsTypeOption[] = [
  { value: "SharedCost", label: "Shared cost" },
  { value: "AccCost", label: "Accumulated cost" },
  { value: "IndivCost", label: "Individual cost" },
];

export const getCtsTypeLabel = (ctsType: CTSType): string | undefined => CTS_TYPE_OPTIONS.find((option) => option.value === ctsType)?.label;
